import { createContext } from 'react';

const useInventoryBalanceContext = createContext();
export default useInventoryBalanceContext;
